import { SuspenseErrorBoundary } from '@/components/SuspenseErrorBoundary';
import { TableTextOverflow } from '@/components/TableTextOverflow/TableTextOverflow';
import { useGetPulldownOptionDetailById } from '@/context/services/transaction_items/Detail/TransactionItemDetail.service';
import { Skeleton } from '@moneyforward/ap-frontend-components';
import { FC, memo, Suspense } from 'react';

type PulldownLabelCellProps = {
  propertyId: string;
  value: string | undefined;
  isLastColumn: boolean;
};

export const InnerPulldownCell: FC<PulldownLabelCellProps> = memo(
  function PulldownLabelCell({ propertyId, value, isLastColumn }) {
    const optionId = value ? String(value).trim() : undefined;

    const { data } = useGetPulldownOptionDetailById(propertyId, optionId ?? '');

    return (
      <TableTextOverflow
        title={data?.label ?? value ?? ''}
        isLastColumn={isLastColumn}
        isTextAlignEnd={false}
      />
    );
  }
);

InnerPulldownCell.displayName = 'InnerPulldownCell';

export const PulldownCell: FC<PulldownLabelCellProps> = memo(
  function PulldownLabelCell({ propertyId, value, isLastColumn }) {
    return (
      <SuspenseErrorBoundary>
        <Suspense fallback={<Skeleton.Input active size='small' block />}>
          <InnerPulldownCell
            propertyId={propertyId}
            value={value}
            isLastColumn={isLastColumn}
          />
        </Suspense>
      </SuspenseErrorBoundary>
    );
  }
);

PulldownCell.displayName = 'PulldownCell';
